/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BoostSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVR4nM2VPWsVURCGN8FIwEIS1MK0Nn7USiK4YggIu/OxgXNn9hJJEbxI4h+w8dr6EwJRkGCjP8CPRmOjlmkETZmkCFZiIQQSw5zdG2PCrtezCE6z7DLnec/MnnlPFP1HMYCoV5KkPVKXlKb5KWD5AKxv+iYnSXsEWF4i608g2UJsXauCI8uq5SHp+77gzHIeSb6U8PXyuY2sdyrhLKv2/kc4sKTI8s1DWZ5PTc2cSEluIckP/y3TGw3geg9IdpB1F1nu2z/4VVV+GUgedLvdwTA4yVzRCv0OLNP7bSCZtCoatcUCSV7YopTz+EC77hbV6O1G8KIC/WwLnXPHvWCmCwYH1ifBbfmtAtY1W9zpdIb8ESXZroMDuHPOuZOBAm4MWB9Xwe0Y22zAdOtqkEBURlVbgOSRPxABArtxHB+rg/tckuVQgaUqeJK1LgFrHixAJO2qnicGNz/KdCFYoGrnAHrRw0ne9gYOWJ+WMzPeCB6ZXbNuAOtKDx7Pzg4D6SfLy7KZM03gR6wCUc8CycfCCHUlCoUjugulNe+bnV08wLJZwt/ddO50ENy+93aJpM8O2zWyLvbsJAhe7NZXsHb4wkkpn++rLR5C8rrOuJxzowdyvhLJ9b7hXoDlIZK+qnNFmwsimTCxv4L/69gDoM16UbBMPhAAAAAASUVORK5CYII=)
 */
export const BoostSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.7 1.3a1 1 0 0 1 0 1.4l-20 20a1 1 0 0 1-1.4-1.4l20-20a1 1 0 0 1 1.4 0ZM5.14 14.28c0 .26.33.4.52.2l1.06-1.06a1 1 0 0 0 .3-.7V8.26c0-.6.23-.93.3-.98l4.37-3.58 2.26 1.85c.2.17.5.15.67-.03l.62-.62a.5.5 0 0 0-.04-.74L12.67 2.1c-.6-.5-1.36-.5-1.97 0L6.13 5.83c-.61.5-.99 1.43-.99 2.43v6.02ZM17.72 9.7a.3.3 0 0 1 .51.2v5.84c0 1-.37 1.93-.98 2.43l-4.58 3.74c-.6.5-1.36.5-1.97 0l-2.43-1.99a.5.5 0 0 1-.03-.74l.61-.62a.5.5 0 0 1 .67-.03l2.17 1.77 4.37-3.58c.07-.05.3-.37.3-.98v-4.27a1 1 0 0 1 .3-.71l1.06-1.07Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.22 10.92a.2.2 0 0 1-.34-.14v-1.2c0-.25.1-.48.28-.66l2.2-2.2a.47.47 0 0 1 .66 0l.35.35c.2.2.2.51 0 .7l-3.15 3.15ZM11.1 17.02a.5.5 0 0 1 0-.7l3.05-3.06a.2.2 0 0 1 .34.14v1.02c0 .25-.1.48-.27.66l-2.2 2.2a.47.47 0 0 1-.66 0l-.26-.26Z"
        className={colorClass}
      />
    </svg>
  );
};
